import React, { FC } from 'react'

import { TrustPilot } from '@smarty-nx/ds'
import cn from 'classnames'

import classes from './trust-pilot.module.scss'
import { FEATURES } from '../../../config'

export const TrustPilotSection: FC<{ transparent?: boolean }> = ({
  transparent,
}) => {
  return (
    <div className={cn(classes.root, transparent && classes.transparent)}>
      <TrustPilot
        reviewTag={
          FEATURES.TRUSTPILOT_UPDATE
            ? 'SMARTY_Homepage_Reviews'
            : 'SelectedReview'
        }
        dataTestId="homepage-trustpilot-widget"
        featureTrustPilot={FEATURES.TRUSTPILOT_UPDATE}
      />
    </div>
  )
}
